import React, { FC, useContext } from 'react';
import moment                    from 'moment';
import { Cell, Grid }            from 'styled-css-grid';

import { TimeService, UserService }        from '../../../../../services';
import { CorvalUserLike }                  from '../../../../../types';
import { OrganizationUser }                from '../../../../components/user/OrganizationUser';
import { UserAvatar }                      from '../../../../components/user-avatar/UserAvatar';
import { DashboardProjectListItemContext } from './ProjectListItem';
import { useProject }                      from "@src/hooks";


interface Props {}

const defaultProps: Props = {}

const ProjectListItemTimestampStatement: FC<Props> = ( props ) => {

    let { project }                              = useContext( DashboardProjectListItemContext ),
        { getMaybeCurrentProjectVersionFromSet } = useProject( project.id );

    const currentProjectVersion = !project.isCorvalManaged && getMaybeCurrentProjectVersionFromSet( project.projectVersions );

    if( currentProjectVersion ){
        project.createdUtc = currentProjectVersion.createdUtc;
        project.createdById = currentProjectVersion.createdById;
        project.updatedUtc = currentProjectVersion.updatedUtc;
        project.updatedById = currentProjectVersion.updatedById;
    }

    let createdTimestamp          = TimeService.ISOtoDisplayDate( project.createdUtc, true ),
        createdTimestampFormatted = TimeService.ISOtoFormat( project.createdUtc, undefined, true ),
        updatedTimestampFormatted = TimeService.ISOtoFormat( project.updatedUtc, undefined, true ),
        humanizedUpdateTimstamp   = TimeService.getHumanizedDays( project.updatedUtc, moment(), true, false, 'seconds' );


    // Updated might be null, so convert to a moment just in case
    let useUpdatedTimestamp = moment( updatedTimestampFormatted ).isAfter( createdTimestampFormatted );

    let descriptorLanguage = {
        action:    useUpdatedTimestamp ? 'Updated' : ' Created',
        timestamp: useUpdatedTimestamp ? humanizedUpdateTimstamp : createdTimestamp,
        userId:    useUpdatedTimestamp ? project.updatedById : project.createdById,
    }

    return (
        <Grid columns={ `repeat(4,auto)` } columnGap={ `5px` } style={ { display: 'inline-grid' } }>
            <Cell middle><strong className={ 'text--colored-dk-screen-50' }>{ descriptorLanguage.action }:</strong></Cell>
            <Cell middle><strong>{ descriptorLanguage.timestamp }</strong></Cell>
            <Cell middle className={ 'text--colored-dk-screen-50' }>by</Cell>
            <Cell middle>
                <OrganizationUser
                    organizationId={ project.organizationId }
                    accountId={ descriptorLanguage.userId }
                    className={ 'display--inline-block' }>

                    { ( user: CorvalUserLike ) => (
                        <Grid columns={ `repeat(2,auto)` } columnGap={ `5px` }>
                            <Cell middle><UserAvatar size={ 'nano' } asInitials={ true } user={ user }/></Cell>
                            <Cell middle>{ UserService.getUserName( user ) }</Cell>
                        </Grid>
                    ) }

                </OrganizationUser>
            </Cell>
        </Grid>
    );
};

ProjectListItemTimestampStatement.defaultProps = defaultProps;

export { ProjectListItemTimestampStatement }
